<h3 id="heading" style="margin-left: 10px; display: none;">Select an Assembly<span class="close-btn" (click)="closePopup()" style="float: right;
    margin: 10px;
    font-size: 20px;
    font-weight: normal;
    cursor: pointer;
    ">X</span></h3>
                                                    <!-- 15_HO_Solid -->
<div id="15_HO_Solid" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HO_Solid/15_HO_Solid_Assembly1.jpg'" (click)="selectImage('Assembly 1')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 1')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 1<br>
                    Single Extended Solid
                    Input; Single Extended
                    Solid Output -
                    Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HO_Solid/15_HO_Solid_Assembly2.jpg'" (click)="selectImage('Assembly 2')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 2')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 2<br>
                    Single Extended Solid
                    Input; Single Extended
                    Solid Output -
                    Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HO_Solid/15_HO_Solid_Assembly3.jpg'" (click)="selectImage('Assembly 3')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 3')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 3<br>
                    Single Extended Solid
                    Input;
                    Double Extended Solid
                    Output Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HO_Solid/15_HO_Solid_Assembly4.jpg'" (click)="selectImage('Assembly 4')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 4')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 4<br>
                    Double Extended Solid
                    Input; Single Extended
                    Solid Output -
                    Left Hand Assembly</p>
                </div>
            </div>
        </div>
<br>
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HO_Solid/15_HO_Solid_Assembly5.jpg'" (click)="selectImage('Assembly 5')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 5')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 5<br>
                    Double Extended Solid
                    Input; Single Extended
                    Solid Output -
                    Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HO_Solid/15_HO_Solid_Assembly6.jpg'" (click)="selectImage('Assembly 6')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 6')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 6<br>
                    Double Extended Solid
                    Input
                    ;
                    Double Extended Solid
                    Output</p>
                </div>
            </div>
            
        </div><br>
    </div>
</div>


                                                            <!-- 15_HU_Solid -->

<div id="15_HU_Solid" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail"  [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HU_Solid/15_HU_Solid_Assembly1.jpg'" (click)="selectImage('Assembly 1')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 1')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 1<br>
                    Single Extended Solid
                    Input; Single Extended
                    Solid Output -
                    Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HU_Solid/15_HU_Solid_Assembly2.jpg'" (click)="selectImage('Assembly 2')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 2')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 2<br>
                    Single Extended Solid
                    Input; Single Extended
                    Solid Output -
                    Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HU_Solid/15_HU_Solid_Assembly3.jpg'" (click)="selectImage('Assembly 3')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 3')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 3<br>
                    Single Extended Solid
                    Input;
                    Double Extended Solid
                    Output</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HU_Solid/15_HU_Solid_Assembly4.jpg'" (click)="selectImage('Assembly 4')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 4')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 4<br>
                    Double Extended Solid
                    Input; Single Extended
                    Solid Output -
                    Left Hand Assembly</p>
                </div>
            </div>
        </div>
<br>
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HU_Solid/15_HU_Solid_Assembly5.jpg'" (click)="selectImage('Assembly 5')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 5')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 5<br>
                    Double Extended Solid
                    Input; Single Extended
                    Solid Output -
                    Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HU_Solid/15_HU_Solid_Assembly6.jpg'" (click)="selectImage('Assembly 6')"/>
                <div class="card-body">
                  <p (click)="selectImage('Assembly 6')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 6<br>
                    Double Extended Solid
                    Input
                    ;
                    Double Extended Solid
                    Output</p>
                </div>
            </div>
            
        </div><br>
    </div>
</div>


                                                            <!-- 15_HU_Solid -->

<div id="15_HU_Solid" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HU_Solid/15_HU_Solid_Assembly1.jpg'" (click)="selectImage('Assembly 1')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 1')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 1<br>
                    Single Extended Solid
                    Input; Single Extended
                    Solid Output -
                    Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HU_Solid/15_HU_Solid_Assembly2.jpg'" (click)="selectImage('Assembly 2')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 2')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 2<br>
                    Single Extended Solid
                    Input; Single Extended
                    Solid Output -
                    Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HU_Solid/15_HU_Solid_Assembly3.jpg'" (click)="selectImage('Assembly 3')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 3')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 3<br>
                    Single Extended Solid
                    Input;
                    Double Extended Solid
                    Output</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HU_Solid/15_HU_Solid_Assembly4.jpg'" (click)="selectImage('Assembly 4')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 4')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 4<br>
                    Double Extended Solid
                    Input; Single Extended
                    Solid Output -
                    Left Hand Assembly</p>
                </div>
            </div>
        </div>
<br>
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HU_Solid/15_HU_Solid_Assembly5.jpg'" (click)="selectImage('Assembly 5')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 5')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 5<br>
                    Double Extended Solid
                    Input; Single Extended
                    Solid Output -
                    Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/15_HU_Solid/15_HU_Solid_Assembly6.jpg'" (click)="selectImage('Assembly 6')"/>
                <div class="card-body">
                  <p (click)="selectImage('Assembly 6')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 6<br>
                    Double Extended Solid
                    Input
                    ;
                    Double Extended Solid
                    Output</p>
                </div>
            </div>
            
        </div><br>
    </div>
</div>

                                                            <!-- 20_25_HO_Solid -->


<div id="20_25_HO_Solid" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HO_Solid/20_25_HO_Solid_Assembly1.jpg'" (click)="selectImage('Assembly 1')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 1')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 1<br>
                    Single Extended Solid
Input, Single Extended
Solid Output -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HO_Solid/20_25_HO_Solid_Assembly2.jpg'" (click)="selectImage('Assembly 2')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 2')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 2<br>
                    Single Extended Solid
Input, Single Extended
Solid Output -
Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HO_Solid/20_25_HO_Solid_Assembly3.jpg'" (click)="selectImage('Assembly 3')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 3')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 3<br>
                    Single Extended Solid
Input,
Double Extended Solid
Output Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HO_Solid/20_25_HO_Solid_Assembly4.jpg'" (click)="selectImage('Assembly 4')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 4')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 4<br>
                    Double Extended SolidInput, Single ExtendedSolid Output - Left HandAssembly</p>
                </div>
            </div>
        </div>
<br>
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HO_Solid/20_25_HO_Solid_Assembly5.jpg'" (click)="selectImage('Assembly 5')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 5')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 5<br>
                    Double Extended SolidInput, Single ExtendedSolid Output - Right HandAssembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HO_Solid/20_25_HO_Solid_Assembly6.jpg'" (click)="selectImage('Assembly 6')"/>
                <div class="card-body">
                  <p (click)="selectImage('Assembly 6')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 6<br>
                    Double Extended SolidInput, Double Extended SolidOutput</p>
                </div>
            </div>
            
        </div><br>
    </div>
</div>

                                                            <!-- 20_25_HU_Solid -->

<div id="20_25_HU_Solid" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HU_Solid/20_25_HU_Solid_Assembly1.jpg'" (click)="selectImage('Assembly 1')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 1')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 1<br>
                    Single Extended Solid
Input, Single Extended
Solid Output -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HU_Solid/20_25_HU_Solid_Assembly2.jpg'" (click)="selectImage('Assembly 2')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 2')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 2<br>
                    Single Extended Solid
Input, Single Extended
Solid Output -
Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HU_Solid/20_25_HU_Solid_Assembly3.jpg'" (click)="selectImage('Assembly 3')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 3')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 3<br>
                    Single Extended Solid
Input,
Double Extended Solid
Output</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HU_Solid/20_25_HU_Solid_Assembly4.jpg'" (click)="selectImage('Assembly 4')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 4')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 4<br>
                    Double Extended Solid
Input, Single Extended
Solid Output -
Left Hand Assembly</p>
                </div>
            </div>
        </div>
<br>
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HU_Solid/20_25_HU_Solid_Assembly5.jpg'" (click)="selectImage('Assembly 5')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 5')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 5<br>
                    Input, Single Extended
Solid Output -
Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HU_Solid/20_25_HU_Solid_Assembly6.jpg'" (click)="selectImage('Assembly 6')"/>
                <div class="card-body">
                  <p (click)="selectImage('Assembly 6')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 6<br>
                    Double Extended Solid
Input,
Double Extended Solid
Output</p>
                </div>
            </div>
            
        </div><br>
    </div>
</div>




                                                            <!-- 20_25_HV_Solid -->

<div id="20_25_HV_Solid" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Solid/20_25_HV_Solid_Assembly7A.jpg'" (click)="selectImage('Assembly 7A')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 7A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 7A<br>
                    Single Input Extension;Solid Output ExtensionOpposite Feet - Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Solid/20_25_HV_Solid_Assembly8A.jpg'" (click)="selectImage('Assembly 8A')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 8A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 8A<br>
                    Single Input Extension;
Solid Output Extension
Opposite Feet -
Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Solid/20_25_HV_Solid_Assembly7B.jpg'" (click)="selectImage('Assembly 7B')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 7B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 7B<br>
                    Single Input Extension;
Solid Output Extension
Opposite Feet -
Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Solid/20_25_HV_Solid_Assembly8B.jpg'" (click)="selectImage('Assembly 8B')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 8B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 8B<br>
                    Single Input Extension;Solid Output ExtensionThrough Feet - Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Solid/20_25_HV_Solid_Assembly7C.jpg'" (click)="selectImage('Assembly 7C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 7C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 7C<br>
                    Single Input Extension;Solid Output DoubleExtension - Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Solid/20_25_HV_Solid_Assembly8C.jpg'" (click)="selectImage('Assembly 8C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 8C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 8C<br>
                    Single Input Extension;Solid Output DoubleExtension - Right Hand Assembly</p>
                </div>
            </div>
        </div>
<br>
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Solid/20_25_HV_Solid_Assembly9A.jpg'" (click)="selectImage('Assembly 9A')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 9A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 9A<br>
                    Double Extended Input;Solid Output ExtensionOpposite Feet - Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Solid/20_25_HV_Solid_Assembly0A.jpg'" (click)="selectImage('Assembly 0A')"/>
                <div class="card-body">
                  <p (click)="selectImage('Assembly 0A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 0A<br>
                    Double Extended Input;Solid Output ExtensionOpposite Feet - Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Solid/20_25_HV_Solid_Assembly9B.jpg'" (click)="selectImage('Assembly 9B')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 9B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 9B<br>
                    Double Extended Input;Solid Output ExtensionThrough Feet - Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Solid/20_25_HV_Solid_Assembly0B.jpg'" (click)="selectImage('Assembly 0B')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 0B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 0B<br>
                    Double Extended Input;Solid Output ExtensionThrough Feet - Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Solid/20_25_HV_Solid_Assembly9C.jpg'" (click)="selectImage('Assembly 9C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 9C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 9C<br>
                    Double Extended Input;
Solid Output Double
Extension -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Solid/20_25_HV_Solid_Assembly0C.jpg'" (click)="selectImage('Assembly 0C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 0C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 0C<br>
                    Double Extended Input;Solid Output DoubleExtension - Right Hand Assembly</p>
                </div>
            </div>
        </div><br>
    </div>
</div>





                                                            <!-- 20_25_HO_Hollow -->


<div id="20_25_HO_Hollow" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HO_Hollow/20_25_HO_Hollow_Assembly1.jpg'" (click)="selectImage('Assembly 1')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 1')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 1<br>
                    Single Extended Solid
Input, Single Extended
Hollow Output -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HO_Hollow/20_25_HO_Hollow_Assembly2.jpg'" (click)="selectImage('Assembly 2')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 2')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 2<br>
                    Single Extended Solid
Input, Single Extended
Hollow Output -
Right
Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HO_Hollow/20_25_HO_Hollow_Assembly3.jpg'" (click)="selectImage('Assembly 3')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 3')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 3<br>
                    Single Extended Solid Input, 
                    Double Extended Hollow Output 
                    Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HO_Hollow/20_25_HO_Hollow_Assembly4.jpg'" (click)="selectImage('Assembly 4')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 4')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 4<br>
                    Double Extended Solid
Input, Single Extended
Hollow Output -
Left Handed Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HO_Hollow/20_25_HO_Hollow_Assembly5.jpg'" (click)="selectImage('Assembly 5')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 5')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 5<br>
                    Double Extended Solid
Input, Single Extended
Hollow Output -
Right
Handed Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HO_Hollow/20_25_HO_Hollow_Assembly6.jpg'" (click)="selectImage('Assembly 6')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 6')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 6<br>
                    Double Extended Solid Input,
                    Double Extended Hollow Output 
                    Assembly</p>
                </div>
            </div>
        </div>
<br>
        
    </div>
</div>






                                                            <!-- 20_25_HU_Hollow -->

<div id="20_25_HU_Hollow" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HU_Hollow/20_25_HU_Hollow_Assembly1.jpg'" (click)="selectImage('Assembly 1')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 1')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 1<br>
                    Single Extended Solid
Input, Single Extended
Hollow Output -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HU_Hollow/20_25_HU_Hollow_Assembly2.jpg'" (click)="selectImage('Assembly 2')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 2')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 2<br>
                    Single Extended Solid
Input, Single Extended
Hollow Output -
Right
Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HU_Hollow/20_25_HU_Hollow_Assembly3.jpg'" (click)="selectImage('Assembly 3')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 3')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 3<br>
                    Single Extended Solid Input, 
                    Double Extended Hollow Output 
                    Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HU_Hollow/20_25_HU_Hollow_Assembly4.jpg'" (click)="selectImage('Assembly 4')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 4')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 4<br>
                    Double Extended Solid
Input, Single Extended
Hollow Output -
Left Handed Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HU_Hollow/20_25_HU_Hollow_Assembly5.jpg'" (click)="selectImage('Assembly 5')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 5')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 5<br>
                    Double Extended Solid
Input, Single Extended
Hollow Output -
Right
Handed Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HU_Hollow/20_25_HU_Hollow_Assembly6.jpg'" (click)="selectImage('Assembly 6')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 6')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 6<br>
                    Double Extended Solid Input,
                    Double Extended Hollow Output 
                    Assembly</p>
                </div>
            </div>
        </div>
<br>
        
    </div>
</div>



                                                            <!-- 20_25_HV_Hollow -->


<div id="20_25_HV_Hollow" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Hollow/20_25_HV_Hollow_Assembly7A.jpg'" (click)="selectImage('Assembly 7A')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 7A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 7A<br>
                    Single Input Extension;
Hollow Output Extension
Opposite Feet -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Hollow/20_25_HV_Hollow_Assembly8A.jpg'" (click)="selectImage('Assembly 8A')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 8A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 8A<br>
                    Single Input Extension;
Hollow Output Extension
Opposite Feet -
Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Hollow/20_25_HV_Hollow_Assembly7B.jpg'" (click)="selectImage('Assembly 7B')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 7B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 7B<br>
                    Single Input Extension;
Hollow Output Extension
Through Feet -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Hollow/20_25_HV_Hollow_Assembly8B.jpg'" (click)="selectImage('Assembly 8B')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 8B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 8B<br>
                    Single Input Extension;
Hollow Output Extension
Through Feet -
Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" style="margin-left: 20px;" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Hollow/20_25_HV_Hollow_Assembly9A.jpg'" (click)="selectImage('Assembly 9A')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 9A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 9A<br>
                    Double Extended Input;
Hollow Output Extension
Opposite Feet -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" style="margin-left: 20px;" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Hollow/20_25_HV_Hollow_Assembly0A.jpg'" (click)="selectImage('Assembly 0A')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 0A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 0A<br>
                    Double Extended Input;
Hollow Output Extension
Opposite Feet -
Right Hand Assembly</p>
                </div>
            </div>
        </div>
<br>
       <div class="row">
         <div style="width: 11rem;">
                <img class="img-thumbnail" style="margin-left: 20px;" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Hollow/20_25_HV_Hollow_Assembly9B.jpg'" (click)="selectImage('Assembly 9B')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 9B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 9B<br>
                    Double Extended Input;
Hollow Output Extension
Through Feet -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" style="margin-left: 20px;" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Hollow/20_25_HV_Hollow_Assembly0B.jpg'" (click)="selectImage('Assembly 0B')"/>
                <div class="card-body">
                  <p (click)="selectImage('Assembly 0B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 0B<br>
                    Double Extended Input;
Hollow Output Extension
Through Feet -
Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Hollow/20_25_HV_Hollow_Assembly7C.jpg'" (click)="selectImage('Assembly 7C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 7C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 7C<br>
                    Single Extended Input; Hollow
Output Extension Both Sides – Left
 Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Hollow/20_25_HV_Hollow_Assembly8C.jpg'" (click)="selectImage('Assembly 8C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 8C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 8C<br>
                    Single Extended Input; Hollow 
                    Output Extension Both Sides – Right 
                    Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Hollow/20_25_HV_Hollow_Assembly9C.jpg'" (click)="selectImage('Assembly 9C')"/>
                <div class="card-body">
                  <p (click)="selectImage('Assembly 9C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 9C<br>
                    Double Extended Input; Hollow 
                    Output Extension Both Sides – Left 
                    Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/20_25_HV_Hollow/20_25_HV_Hollow_Assembly0C.jpg'" (click)="selectImage('Assembly 0C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 0C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 0C<br>
                    Double Extended Input; Hollow 
                    Output Extension Both Sides – 
                    Right Hand Assembly</p>
                </div>
            </div>
        </div><br> 
    </div>
</div>





                                                            <!-- 30_120_HO_Solid -->


 
<div id="30_120_HO_Solid" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HO_Solid/30_120_HO_Solid_Assembly1.jpg'" (click)="selectImage('Assembly 1')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 1')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 1<br>
                    Single Extended Solid
Input, Single Extended
Solid Output -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HO_Solid/30_120_HO_Solid_Assembly2.jpg'" (click)="selectImage('Assembly 2')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 2')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 2<br>
                    Single Extended Solid
Input, Single Extended
Solid Output -
Right
Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HO_Solid/30_120_HO_Solid_Assembly3.jpg'" (click)="selectImage('Assembly 3')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 3')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 3<br>
                    Single Extended Solid
Input,
Double Extended Solid
Output Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HO_Solid/30_120_HO_Solid_Assembly4.jpg'" (click)="selectImage('Assembly 4')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 4')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 4<br>
                    Double Extended Solid
Input, Single Extended
Solid Output -
Left Hand Assembly</p>
                </div>
            </div>
        </div>
<br>
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HO_Solid/30_120_HO_Solid_Assembly5.jpg'" (click)="selectImage('Assembly 5')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 5')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 5<br>
                    Double Extended Solid
Input, Single Extended
Solid Output -
Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HO_Solid/30_120_HO_Solid_Assembly6.jpg'" (click)="selectImage('Assembly 6')"/>
                <div class="card-body">
                  <p (click)="selectImage('Assembly 6')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 6<br>
                    Double Extended Solid
Input,
Double Extended Solid
Output</p>
                </div>
            </div>
            
        </div><br>
    </div>
</div>




                                                            <!-- 30_120_HU_Solid -->



<div id="30_120_HU_Solid" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HU_Solid/30_120_HU_Solid_Assembly1.jpg'" (click)="selectImage('Assembly 1')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 1')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 1<br>
                    Single Extended Solid
Input, Single Extended
Solid Output -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HU_Solid/30_120_HU_Solid_Assembly2.jpg'" (click)="selectImage('Assembly 2')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 2')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 2<br>
                    Single Extended Solid
Input, Single Extended
Solid Output -
Right
Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HU_Solid/30_120_HU_Solid_Assembly3.jpg'" (click)="selectImage('Assembly 3')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 3')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 3<br>
                    Single Extended Solid
Input,
Double Extended Solid
Output Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HU_Solid/30_120_HU_Solid_Assembly4.jpg'" (click)="selectImage('Assembly 4')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 4')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 4<br>
                    Double Extended Solid
Input, Single Extended
Solid Output -
Left Hand Assembly</p>
                </div>
            </div>
        </div>
<br>
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HU_Solid/30_120_HU_Solid_Assembly5.jpg'" (click)="selectImage('Assembly 5')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 5')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 5<br>
                    Double Extended Solid
Input, Single Extended
Solid Output -
Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HU_Solid/30_120_HU_Solid_Assembly6.jpg'" (click)="selectImage('Assembly 6')"/>
                <div class="card-body">
                  <p (click)="selectImage('Assembly 6')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 6<br>
                    Double Extended Solid
Input,
Double Extended Solid
Output</p>
                </div>
            </div>
            
        </div><br>
    </div>
</div>







                                                            <!-- 30_120_HV_Solid -->


 
<div id="30_120_HV_Solid" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Solid/30_120_HV_Solid_Assembly7A.jpg'" (click)="selectImage('Assembly 7A')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 7A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 7A<br>
                    Single Input Extension;Solid Output ExtensionOpposite Feet - Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Solid/30_120_HV_Solid_Assembly8A.jpg'" (click)="selectImage('Assembly 8A')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 8A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 8A<br>
                    Single Input Extension;Solid Output ExtensionOpposite Feet - Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Solid/30_120_HV_Solid_Assembly7B.jpg'" (click)="selectImage('Assembly 7B')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 7B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 7B<br>
                    Single Input Extension;Solid Output ExtensionThrough Feet - Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Solid/30_120_HV_Solid_Assembly8B.jpg'" (click)="selectImage('Assembly 8B')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 8B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 8B<br>
                    Single Input Extension;Solid Output ExtensionThrough Feet - Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Solid/30_120_HV_Solid_Assembly7C.jpg'" (click)="selectImage('Assembly 7C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 7C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 7C<br>
                    Single Input Extension;Solid Output DoubleExtension - Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Solid/30_120_HV_Solid_Assembly8C.jpg'" (click)="selectImage('Assembly 8C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 8C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 8C<br>
                    Single Input Extension;Solid Output DoubleExtension - Right Hand Assembly</p>
                </div>
            </div>
        </div>
<br>
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Solid/30_120_HV_Solid_Assembly9A.jpg'" (click)="selectImage('Assembly 9A')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 9A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 9A<br>
                    Double Extended Input;Solid Output ExtensionOpposite Feet - Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Solid/30_120_HV_Solid_Assembly0A.jpg'" (click)="selectImage('Assembly 0A')"/>
                <div class="card-body">
                  <p (click)="selectImage('Assembly 0A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 0A<br>
                    Double Extended Input;Solid Output ExtensionOpposite Feet - Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Solid/30_120_HV_Solid_Assembly9B.jpg'" (click)="selectImage('Assembly 9B')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 9B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 9B<br>
                    Double Extended Input;Solid Output ExtensionThrough Feet - Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Solid/30_120_HV_Solid_Assembly0B.jpg'" (click)="selectImage('Assembly 0B')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 0B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 0B<br>
                    Double Extended Input;Solid Output ExtensionThrough Feet - Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Solid/30_120_HV_Solid_Assembly9C.jpg'" (click)="selectImage('Assembly 9C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 9C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 9C<br>
                    Double Extended Input;Solid Output DoubleExtension - Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Solid/30_120_HV_Solid_Assembly0C.jpg'" (click)="selectImage('Assembly 0C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 0C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 0C<br>
                    Double Extended Input;Solid Output DoubleExtension - Right Hand Assembly</p>
                </div>
            </div>
        </div><br>
    </div>
</div>





                                                            <!-- 30_120_HO_Hollow -->
 
<div id="30_120_HO_Hollow" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HO_Hollow/30_120_HO_Hollow_Assembly1.jpg'" (click)="selectImage('Assembly 1')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 1')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 1<br>
                    Single Extended Solid
Input, Single Extended
Hollow Output -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HO_Hollow/30_120_HO_Hollow_Assembly2.jpg'" (click)="selectImage('Assembly 2')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 2')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 2<br>
                    Single Extended Solid
Input, Single Extended
Hollow Output -
Right
Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HO_Hollow/30_120_HO_Hollow_Assembly3.jpg'" (click)="selectImage('Assembly 3')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 3')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 3<br>
                    Single Extended Solid Input, 
                    Double Extended Hollow Output 
                    Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HO_Hollow/30_120_HO_Hollow_Assembly4.jpg'" (click)="selectImage('Assembly 4')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 4')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 4<br>
                    Double Extended Solid
Input, Single Extended
Hollow Output -
Left Handed Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HO_Hollow/30_120_HO_Hollow_Assembly5.jpg'" (click)="selectImage('Assembly 5')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 5')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 5<br>
                    Double Extended Solid
Input, Single Extended
Hollow Output -
Right
Handed Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HO_Hollow/30_120_HO_Hollow_Assembly6.jpg'" (click)="selectImage('Assembly 6')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 6')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 6<br>
                    Double Extended Solid Input,
                    Double Extended Hollow Output 
                    Assembly</p>
                </div>
            </div>
        </div>
<br>
        
    </div>
</div>








                                                            <!-- 30_120_HU_Hollow -->


<div id="30_120_HU_Hollow" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HU_Hollow/30_120_HU_Hollow_Assembly1.jpg'" (click)="selectImage('Assembly 1')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 1')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 1<br>
                    Single Extended Solid
Input, Single Extended
Hollow Output -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HU_Hollow/30_120_HU_Hollow_Assembly2.jpg'" (click)="selectImage('Assembly 2')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 2')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 2<br>
                    Single Extended Solid
Input, Single Extended
Hollow Output -
Right
Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HU_Hollow/30_120_HU_Hollow_Assembly3.jpg'" (click)="selectImage('Assembly 3')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 3')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 3<br>
                    Single Extended Solid Input, 
                    Double Extended Hollow Output 
                    Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HU_Hollow/30_120_HU_Hollow_Assembly4.jpg'" (click)="selectImage('Assembly 4')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 4')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 4<br>
                    Double Extended Solid
Input, Single Extended
Hollow Output -
Left Handed Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HU_Hollow/30_120_HU_Hollow_Assembly5.jpg'" (click)="selectImage('Assembly 5')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 5')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 5<br>
                    Double Extended SolidInput, Single ExtendedHollow Output - Right Handed Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HO_Hollow/30_120_HO_Hollow_Assembly6.jpg'" (click)="selectImage('Assembly 6')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 6')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 6<br>
                    Double Extended Solid Input,
                    Double Extended Hollow Output 
                    Assembly</p>
                </div>
            </div>
        </div>
<br>
        
    </div>
</div>








                                                            <!-- 30_120_HV_Hollow -->


<div id="30_120_HV_Hollow" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Hollow/30_120_HV_Hollow_Assembly7A.jpg'" (click)="selectImage('Assembly 7A')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 7A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 7A<br>
                    Single Input Extension;
Hollow Output Extension
Opposite Feet -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Hollow/30_120_HV_Hollow_Assembly8A.jpg'" (click)="selectImage('Assembly 8A')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 8A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 8A<br>
                    Single Input Extension;
Hollow Output Extension
Opposite Feet -
Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Hollow/30_120_HV_Hollow_Assembly7B.jpg'" (click)="selectImage('Assembly 7B')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 7B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 7B<br>
                    Single Input Extension;
Hollow Output Extension
Through Feet -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Hollow/30_120_HV_Hollow_Assembly8B.jpg'" (click)="selectImage('Assembly 8B')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 8B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 8B<br>
                    Single Input Extension;
Hollow Output Extension
Through Feet -
Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Hollow/30_120_HV_Hollow_Assembly9A.jpg'" (click)="selectImage('Assembly 9A')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 9A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 9A<br>
                    Double Extended Input
;
Hollow Output Opposite
Feet -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Hollow/30_120_HV_Hollow_Assembly0A.jpg'" (click)="selectImage('Assembly 0A')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 0A')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 0A<br>
                    Double Extended Input;
Hollow Output Opposite
Feet -
Right
Hand Assembly</p>
                </div>
            </div>
        </div>
<br>
        <div class="row">
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Hollow/30_120_HV_Hollow_Assembly9B.jpg'" (click)="selectImage('Assembly 9B')"/>
                <div class="card-body">
                  <p (click)="selectImage('Assembly 9B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 9B<br>
                    Double Extended Input;
Hollow Output Extension
Through Feet -
Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Hollow/30_120_HV_Hollow_Assembly0B.jpg'" (click)="selectImage('Assembly 0B')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 0B')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 0B<br>
                    Double Extended Input;
Hollow Output Extension
Through Feet -
Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Hollow/30_120_HV_Hollow_Assembly7C.jpg'" (click)="selectImage('Assembly 7C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 7C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 7C<br>
                    Single Extended Input; Hollow
Output Extension Both Sides – Left
 Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Hollow/30_120_HV_Hollow_Assembly8C.jpg'" (click)="selectImage('Assembly 8C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 8C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 8C<br>
                    Single Extended Input; Hollow 
                    Output Extension Both Sides – Right 
                    Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Hollow/30_120_HV_Hollow_Assembly9C.jpg'" (click)="selectImage('Assembly 9C')"/>
                <div class="card-body">
                  <p (click)="selectImage('Assembly 9C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 9C<br>
                    Double Extended Input; Hollow 
                    Output Extension Both Sides – Left 
                    Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/30_120_HV_Hollow/30_120_HV_Hollow_Assembly0C.jpg'" (click)="selectImage('Assembly 0C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 0C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 0C<br>
                    Double Extended Input; Hollow 
                    Output Extension Both Sides – 
                    Right Hand Assembly</p>
                </div>
            </div>
        </div><br>




    </div>
</div>



                                                            <!-- 100_120_HO_Hollow -->
<div id="100_120_HO_Hollow" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/100_120_HO_Hollow/3.jpg'" (click)="selectImage('Assembly 3')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 3')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 3<br>
                    Single Extended Solid Input, Double Extended Hollow Output</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/100_120_HO_Hollow/6.jpg'" (click)="selectImage('Assembly 6')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 6')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 6<br>
                    Double Extended Solid Input, Double Extended Hollow Output</p>
                </div>
            </div>
        </div>
<br>
        <br>
    </div>
</div>
                                                            <!-- 100_120_HU_Hollow -->
<div id="100_120_HU_Hollow" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/100_120_HO_Hollow/3.jpg'" (click)="selectImage('Assembly 3')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 3')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 3<br>
                    Single Extended Solid Input, Double Extended Hollow Output</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/100_120_HO_Hollow/6.jpg'" (click)="selectImage('Assembly 6')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 6')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 6<br>
                    Double Extended Solid Input, Double Extended Hollow Output</p>
                </div>
            </div>
        </div>
<br>
        <br>
    </div>
</div>
                                                            <!-- 100_120_HV_Hollow -->
<div id="100_120_HV_Hollow" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/100_120_HV_Hollow/7C.jpg'" (click)="selectImage('Assembly 7C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 7C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 7C<br>
                    Single Input Extension; Double Extended Hollow Output – Left Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/100_120_HV_Hollow/8C.jpg'" (click)="selectImage('Assembly 8C')" />
                <div class="card-body">
                  <p (click)="selectImage('Assembly 8C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 8C<br>
                    Single Input Extension; Double Extended Hollow Output – Right Hand Assembly</p>
                </div>
            </div>
            <div style="width: 11rem;">
              <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/100_120_HV_Hollow/9C.jpg'" (click)="selectImage('Assembly 9C')" />
              <div class="card-body">
                <p (click)="selectImage('Assembly 9C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 9C<br>
                  Double Input Extension; Double Extended Hollow Output – Left Hand Assembly</p>
              </div>
          </div>
          <div style="width: 11rem;">
              <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Assembly/100_120_HV_Hollow/0C.jpg'" (click)="selectImage('Assembly 0C')" />
              <div class="card-body">
                <p (click)="selectImage('Assembly 0C')" class="card-text" style="font-size: 11px;font-weight: bold;">Hand of Assembly 0C<br>
                  Double Input Extension; Double Extended Hollow Output – Right Hand Assembly</p>
              </div>
          </div>
        </div>
<br>
        <br>
    </div>
</div>